/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Disabled_ToastInputs */

const en_live_caption_disabled_toast = /** @type {(inputs: Live_Caption_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live captioning disabled.`)
};

const fr_live_caption_disabled_toast = /** @type {(inputs: Live_Caption_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titrage en direct désactivé.`)
};

const de_live_caption_disabled_toast = /** @type {(inputs: Live_Caption_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Untertitelung deaktiviert.`)
};

const it_live_caption_disabled_toast = /** @type {(inputs: Live_Caption_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli in tempo reale disabilitati.`)
};

const ru_live_caption_disabled_toast = /** @type {(inputs: Live_Caption_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры в реальном времени отключены.`)
};

const es_live_caption_disabled_toast = /** @type {(inputs: Live_Caption_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulos en directo desactivados.`)
};

const zh_cn2_live_caption_disabled_toast = /** @type {(inputs: Live_Caption_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时字幕已关闭。`)
};

const ja_live_caption_disabled_toast = /** @type {(inputs: Live_Caption_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブ字幕は無効になっています。`)
};

const hi_live_caption_disabled_toast = /** @type {(inputs: Live_Caption_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव कैप्शनिंग अक्षम है।`)
};

const pt_pt2_live_caption_disabled_toast = /** @type {(inputs: Live_Caption_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas ao vivo desativadas.`)
};

/**
* | output |
* | --- |
* | "Live captioning disabled." |
*
* @param {Live_Caption_Disabled_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_disabled_toast = /** @type {((inputs?: Live_Caption_Disabled_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Disabled_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_disabled_toast(inputs)
	if (locale === "de") return de_live_caption_disabled_toast(inputs)
	if (locale === "it") return it_live_caption_disabled_toast(inputs)
	if (locale === "ru") return ru_live_caption_disabled_toast(inputs)
	if (locale === "es") return es_live_caption_disabled_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_disabled_toast(inputs)
	if (locale === "ja") return ja_live_caption_disabled_toast(inputs)
	if (locale === "hi") return hi_live_caption_disabled_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_disabled_toast(inputs)
	return en_live_caption_disabled_toast(inputs)
});